"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ({ isEditing }) => {
    return {
        schemaType: "object",
        properties: [
            {
                title: "email",
                propertyName: "email",
                schema: { schemaType: "text", readOnly: isEditing, trim: true },
            },
            {
                title: "権限",
                propertyName: "role",
                schema: {
                    schemaType: "selector",
                    required: true,
                    options: [
                        {
                            title: "システム管理者",
                            value: "master",
                        },
                    ],
                },
            },
            {
                title: "氏名",
                propertyName: "name",
                schema: { schemaType: "text" },
            },
            {
                title: "所属",
                propertyName: "organization",
                schema: { schemaType: "text" },
            },
            {
                title: "エラーコード",
                propertyName: "errorCode",
                schema: { schemaType: "text", readOnly: true },
            },
        ],
    };
};
